module.exports = __webpack_public_path__ + "static/helvetica-neue-b49e235f336ad7237b5703707d53a1fe.woff";